module.exports = __webpack_public_path__ + "img/keycloak.5cb5123b.svg";